import styles from "components/header/Header.module.css";
import SearchKidsSelect from "components/searchKids/searchKids";
import { IoLogOutOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { logout } from "services/userLogin/logout";


interface Section {
    id: string;
    label: string;
}

interface HeaderProps {
    sections: Section[];
    activeSection: string;
    onTabChange: (id: string) => void;
    isWithSearch: boolean
}

export default function LogedinHeaderComponent({ sections, activeSection, onTabChange, isWithSearch }: HeaderProps) {
    const navigate = useNavigate();
    const handleLogout = () => {
        logout();
        navigate('/reservierungsportal');
    };

    return (
        <>
            <div className={styles.middel_col}>
                <div className={styles.searchContainer}>
                    {isWithSearch && <SearchKidsSelect />}
                </div>
                <nav >
                    <ul className={styles.middel_col_grid}>
                        {sections.map((section) => (
                            <li
                                key={section.id}
                                className={`${styles.middel_col_grid_item} ${activeSection === section.id ? styles.activesectiobn : ""}`}
                                onClick={() => onTabChange(section.id)}
                            >
                                {section.label}
                            </li>
                        ))}
                    </ul>
                </nav>


            </div>
            <div className={styles.right_col}>
                <button className={styles.logoutButton} onClick={handleLogout}>
                    <IoLogOutOutline className={styles.logoutButtonIcon} />
                </button>
            </div>
        </>
    );
}
